import * as React from 'react'
import { InputBase as Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

/**
 * Figma (node 65:533 — Input component):
 *
 * Container: h-8 (32px), rounded-lg (10px), px-2.5 (10px), py-1 (4px),
 *   border border-input, bg-background, text-sm (14px)
 *
 * Variants: Default, File, Password (handled via native type prop)
 *
 * States:
 *   Default:  border-input, bg-background
 *   Focus:    border-ring, ring-1 ring-ring/50
 *   Filled:   text-foreground (not muted)
 *   Disabled: opacity-50, bg-input/50, cursor-not-allowed
 *   Invalid:  border-destructive, ring-destructive/20
 */
export interface IntuiInputProps extends React.ComponentProps<'input'> {
  /** Render with destructive (red) border and focus ring */
  invalid?: boolean
}

const IntuiInput = React.forwardRef<HTMLInputElement, IntuiInputProps>(
  ({ className, invalid, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        className={cn(
          'h-8 rounded-lg px-2.5',
          invalid && 'border-destructive focus-visible:ring-destructive/20',
          className,
        )}
        aria-invalid={invalid || undefined}
        {...props}
      />
    )
  },
)
IntuiInput.displayName = 'IntuiInput'

export { IntuiInput }
